import FormDivider from '@form/FormDivider';
import FormInput from '@form/FormInput';
import { useTranslation } from 'react-i18next';
import AccountFormInput from '../../UserInvoice/Account/AccountFormInput';
import CostCenterFormInput from '../../UserInvoice/CostCenter/CostCenterFormInput';

/** Renders all fields from the SpaceManager Price effect inside a collapsible section. Binds to meta.price.* within the enclosing React Hook Form context. */
const AllocationCustomPrice = () => {
    const { t } = useTranslation('space-manager');

    return (
        <FormDivider title={t('allocation.customPrice.title')} collapsible fieldKeys={['meta']}>
            <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                <FormInput
                    type="number"
                    step={0.01}
                    min={0}
                    name="meta.price.price"
                    label={t('allocation.customPrice.priceLabel')}
                    labelRight={t('allocation.customPrice.priceUnit')}
                />
                <FormInput
                    type="number"
                    step={0.01}
                    min={0}
                    name="meta.price.taxes"
                    label={t('allocation.customPrice.taxLabel')}
                    labelRight="%"
                />
            </div>
            <FormInput.Checkbox name="meta.price.price_per_hour" label={t('allocation.customPrice.perHour')} />
            <FormInput name="meta.price.description" label={t('allocation.customPrice.description')} />
            <div className="tw-grid tw-grid-cols-3 tw-gap-4">
                <CostCenterFormInput name="meta.price.user_invoice_cost_1" label={t('allocation.customPrice.costCenter1')} />
                <CostCenterFormInput name="meta.price.user_invoice_cost_2" label={t('allocation.customPrice.costCenter2')} />
                <AccountFormInput name="meta.price.user_invoice_account_number" label={t('allocation.customPrice.account')} />
            </div>
        </FormDivider>
    );
};

export default AllocationCustomPrice;
